import { render, staticRenderFns } from "./PollsSection.vue?vue&type=template&id=f144db24&scoped=true"
import script from "./PollsSection.vue?vue&type=script&lang=js"
export * from "./PollsSection.vue?vue&type=script&lang=js"
import style0 from "./PollsSection.vue?vue&type=style&index=0&id=f144db24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f144db24",
  null
  
)

export default component.exports